module.exports = __webpack_public_path__ + "static/logo_alumni-80a4a6d7d23cfa34fe5b4efefde82626.png";